export const InvoiceLOADING = "invoice/Loading";
export const InvoiceERROR = "invoice/Error";
export const InvoiceListSUCCESS = "invoice/ListSuccess";
export const InvoiceUpdateSUCCESS = "invoice/UpdateSuccess";
export const InvoiceDeleteSUCCESS = "invoice/DeleteSuccess";
